/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { FindAllOrganisationDetailsQueryResponse, FindAllOrganisationDetails400, FindAllOrganisationDetails401, FindAllOrganisationDetails404, FindAllOrganisationDetails409, FindAllOrganisationDetails500 } from "../../types/FindAllOrganisationDetails.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getFindAllOrganisationDetailsUrl() {
  const res = { method: 'GET', url: `/api/me/organisation` as const }
  return res
}

/**
 * {@link /api/me/organisation}
 */
export async function findAllOrganisationDetails(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<FindAllOrganisationDetailsQueryResponse, ResponseErrorConfig<FindAllOrganisationDetails400 | FindAllOrganisationDetails401 | FindAllOrganisationDetails404 | FindAllOrganisationDetails409 | FindAllOrganisationDetails500>, unknown>({ method : "GET", url : getFindAllOrganisationDetailsUrl().url.toString(), ... requestConfig })
  return res.data
}